import React from "react";
import { Box, Typography } from "@mui/material";
import { theme } from "../../theme/colors";
import {
  AVAILABLE_POST_TYPES,
  POST_TYPE_DESCRIPTIONS,
  POST_TYPE_ICONS,
  POST_TYPE_PICKER_LABEL,
  POST_TYPE_TILE_LABELS,
} from "../../utils/postTypeConfig";

export default function PostTypeChipBar({ value, onChange, disabled = false }) {
  return (
    <Box sx={{ mb: 2 }}>
      <Typography
        sx={{
          fontSize: 15,
          color: theme.textBody,
          mb: 1,
          lineHeight: 1.5,
          fontWeight: 500,
        }}
      >
        {POST_TYPE_PICKER_LABEL}
      </Typography>
      <Box
        role="radiogroup"
        aria-label={POST_TYPE_PICKER_LABEL}
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(96px, 1fr))",
          gap: 1,
          width: "100%",
        }}
      >
        {AVAILABLE_POST_TYPES.map((type) => {
          const selected = value === type;
          const icon = POST_TYPE_ICONS[type];

          return (
            <Box
              key={type}
              role="radio"
              aria-checked={selected}
              component="button"
              type="button"
              disabled={disabled}
              onClick={() => !disabled && onChange(type)}
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                gap: 0.5,
                width: "100%",
                minHeight: 44,
                px: 1,
                py: 0.75,
                borderRadius: "10px",
                border: `1px solid ${theme.primary}`,
                bgcolor: selected ? theme.primary : theme.background,
                color: selected ? theme.background : theme.primary,
                cursor: disabled ? "default" : "pointer",
                opacity: disabled ? 0.7 : 1,
                "&:hover": disabled
                  ? {}
                  : {
                      bgcolor: selected ? theme.primaryHover : theme.background,
                      borderColor: theme.primaryHover,
                      color: selected ? theme.background : theme.primaryHover,
                    },
                "&:focus-visible": {
                  boxShadow: theme.joinFocusRing,
                  outline: "none",
                },
              }}
            >
              {icon && (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    color: "inherit",
                    "& svg": { fontSize: 18 },
                    flexShrink: 0,
                  }}
                >
                  {icon}
                </Box>
              )}
              <Typography
                component="span"
                sx={{
                  fontSize: 12,
                  fontWeight: selected ? 700 : 600,
                  lineHeight: 1.2,
                  color: "inherit",
                  textAlign: "center",
                }}
              >
                {POST_TYPE_TILE_LABELS[type]}
              </Typography>
            </Box>
          );
        })}
      </Box>
      {value && (
        <Typography sx={{ fontSize: 17, fontWeight: 700, color: "#0f172a", mt: 1.25, lineHeight: 1.45 }}>
          {POST_TYPE_DESCRIPTIONS[value]}
        </Typography>
      )}
    </Box>
  );
}
